import { useQuery } from 'react-query';
import axios from 'api/axiosInstance';

interface AiReview {
  id: number;
  patientId: number;
  patientName?: string;
  reviewType?: string;
  reviewDate: string;
  createdAt: string;
  deletedAt?: string;
  [key: string]: any;
}

interface UseDeletedAiReviewsParams {
  page?: number;
  limit?: number;
}

export const useDeletedAiReviews = ({ page = 1, limit = 10 }: UseDeletedAiReviewsParams = {}) => {
  const offset = (page - 1) * limit;

  return useQuery({
    queryKey: ['deletedAiReviews', page, limit],
    queryFn: async () => {
      const response = await axios.get<{ error: number; data: AiReview[]; message: string }>('/api/v1/ai-reviews', {
        params: {
          onlyDeleted: true,
          limit,
          offset,
        },
      });
      return response.data.data; // response.data.data로 실제 배열 반환
    },
    staleTime: 5 * 60 * 1000, // 5분
    keepPreviousData: true, // 페이지 전환 시 이전 데이터 유지
  });
};